import { useState } from 'react';
import styles from './FooterSubscribe.module.css';

const FooterSubscribe = () => {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');

    try {
      const response = await fetch('https://api.brevo.com/v3/contacts', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'api-key': process.env.REACT_APP_BREVO_API_KEY,
        },
        body: JSON.stringify({
          email,
          listIds: [2],
          updateEnabled: true,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setStatus("You're on the list!");
      } else {
        setStatus(`Failed: ${data.message}`);
      }
    } catch (error) {
      setStatus('Something went wrong.');
    }

    setTimeout(() => {
      setEmail('');
      setStatus('');
    }, 4000);
  };

  return (
    <div className={styles.subscribeSection}>
      <h3 className={styles.title}>subscribe.</h3>
      <form onSubmit={handleSubmit} className={styles.form}>
        <input
          type="email"
          placeholder="Email Address"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className={styles.input}
        />
        <button type="submit" className={styles.button}>
          subscribe
        </button>
      </form>
      {status && <p className={styles.status}>{status}</p>}
    </div>
  );
};

export default FooterSubscribe;